import { ReactComponent as FilterConcepts } from 'assets/icons/icon-filter-concepts.svg';

export default FilterConcepts;
